var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpertTitle = function SvgExpertTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__a)",
    d: "m60.112 6.584.552-3.168h1.176l.504-2.808h4.08l-.504 2.808h2.616l-.552 3.168h-2.616l-.672 3.84c-.12.672.072.984.84.984.48 0 1.056-.168 1.416-.264l-.216 3.648c-.984.288-1.512.456-2.76.456-2.952 0-3.84-2.136-3.408-4.608l.72-4.056z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__b)",
    d: "m56.41 3.416-.696 4.032.288.024c1.392-3.768 2.423-4.176 3.743-4.176h.288L59.193 8h-.767c-2.16 0-2.665.48-2.953 2.136l-.84 4.752h-4.08L52.57 3.416z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__c)",
    d: "M43.888 15.248c-3.432 0-5.76-2.088-4.944-6.624.6-3.528 2.952-5.568 6.504-5.568 3.888 0 5.256 2.448 4.728 5.592-.096.456-.168.768-.288 1.224h-7.176c-.096 1.56.408 2.136 1.632 2.136 1.152 0 1.584-.528 1.896-1.176l3.288 1.008c-.816 1.824-2.256 3.408-5.64 3.408m-.912-6.936h3.528c.312-1.56-.192-2.256-1.368-2.256-1.128 0-1.752.6-2.16 2.256"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__d)",
    d: "M37.836 9.44c-.672 3.84-2.4 5.808-4.608 5.808-1.728 0-2.688-1.272-2.952-3.312h-.192l-1.152 6.576h-4.08l2.64-15.096h4.08l-.504 2.808h.216c.984-2.04 2.328-3.168 3.936-3.168 2.304 0 3.312 2.256 2.616 6.384m-7.176-.864-.192 1.152.024-.048c-.216 1.224.288 1.992 1.248 1.992 1.224 0 1.848-.792 2.136-2.424.288-1.68-.12-2.52-1.248-2.52-.96 0-1.68.696-1.968 1.848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__e)",
    d: "M14.37 3.416h4.583l.624 4.08h.336l1.896-4.08h4.488l-.024.264-3.72 5.784 1.944 5.16-.048.264h-4.584l-.6-4.152h-.36l-1.872 4.152h-4.728l.048-.264 3.888-5.808-1.896-5.136z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#expertTitle_svg__f)",
    d: "M11.472 14.888H0L2.544.488h11.472l-.648 3.72H6.216l-.36 1.92h6.672L12 9.176H5.328l-.36 1.992h7.176z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__a",
    x1: 94.266,
    x2: -22.069,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__b",
    x1: 94.266,
    x2: -22.069,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__c",
    x1: 94.266,
    x2: -22.069,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__d",
    x1: 94.266,
    x2: -22.068,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__e",
    x1: 94.266,
    x2: -22.069,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "expertTitle_svg__f",
    x1: 94.266,
    x2: -22.069,
    y1: 0.247,
    y2: 14.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FFE09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C357"
  })))));
};
export default SvgExpertTitle;